import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { currencyFormat } from "../../Utils";
import { isDepositApplication } from "../../Utils/DepositUtil";

const PaymentHistoryList = ({ payments, onViewPayment }) => {
  const { t, i18n } = useTranslation();
  if (!payments?.length) return null;
  return (
    <div className="bg-white shadow sm:rounded-lg border border-gray-100 overflow-hidden">
      <div className="px-4 py-3 sm:px-6 border-b border-gray-100">
        <h4 className="text-sm font-semibold text-gray-700 uppercase tracking-wider">
          {t("invoices.detail.fields.paymentHistory")}
        </h4>
      </div>
      <ul className="divide-y divide-gray-100">
        {payments.map((payment, index) => {
          // A deposit applied to the invoice sits among its payments; it is
          // named after the deposit so it does not read as cash received.
          const fromDeposit = isDepositApplication(payment);
          return (
            <li
              key={payment.id || index}
              onClick={() => onViewPayment?.(payment)}
              className={`px-4 py-3 sm:px-6 flex justify-between items-center gap-3 text-sm ${
                onViewPayment ? "cursor-pointer hover:bg-gray-50" : ""
              }`}
            >
              <span className="min-w-0">
                {fromDeposit && (
                  <span className="flex flex-wrap items-center gap-2">
                    <span className="font-medium text-gray-900">
                      {t("deposits.apply.paymentLabel", {
                        interpolation: { escapeValue: false },
                        number: payment.depositNumber || "-",
                      })}
                    </span>
                    <span className="rounded-full bg-purple-100 px-2 text-xs font-semibold leading-5 text-purple-800">
                      {t("deposits.apply.chip")}
                    </span>
                  </span>
                )}
                <span className="block text-gray-500">
                  {dayjs(payment.createdAt)
                    .locale(i18n.language)
                    .format("DD MMM YYYY")}
                </span>
              </span>
              <span className="font-medium tabular-nums text-gray-900">
                {currencyFormat(payment.total)}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PaymentHistoryList;
